import type { MutableRefObject } from 'react';
import { createContext } from 'react';
import type {
    GraphReportTypeFieldsFragment,
    UpdateGraphReportLastDownloadedMutation,
    UpdateGraphReportLastDownloadedMutationVariables,
    FileType,
} from '@/graphql/types';
import type { useMutation } from '@apollo/client';
import type { DataSet, MultiSensorDataSet } from '../../../graph/dataset';

export type ExportDataSet = DataSet & Pick<MultiSensorDataSet, 'currentSensor$'>;

export interface ExportContextProps {
    dataSet: ExportDataSet;
    createGraphReport: (
        exportType: FileType,
        extraParameters?: Record<string, unknown>,
        customDateRange?: [number, number] | null
    ) => void;
    datePickerExportType: MutableRefObject<FileType>;
    openDatePickerForExportType: (exportType: string) => void;
    isDatePickerOpen: boolean;
    setIsDatePickerOpen: (isOpen: boolean) => void;
    setShowStatusPopup: (show: boolean) => void;
    showStatusPopup: boolean;
    downloadFiles: GraphReportTypeFieldsFragment[];
    updateLastDownloadMutation: ReturnType<
        typeof useMutation<
            UpdateGraphReportLastDownloadedMutation,
            UpdateGraphReportLastDownloadedMutationVariables
        >
    >[0];
}

const ExportContext = createContext<ExportContextProps | null>(null);

export default ExportContext;
